/**
 * Internal dependencies
 */
import PhotoboothsMenu from './modules/menu';
import PhotoboothsSearch from './modules/search';
import PhotoboothsLocations from './modules/locations';
import PhotoboothsPerformanceTable from './modules/performance-table';

( function() {
	PhotoboothsMenu.init();
	PhotoboothsSearch.init();
	PhotoboothsLocations.init( '.wp-block-photobooths-header__location-select' );
	PhotoboothsPerformanceTable.init();

	// red
	// orange
	// tangerine
	// gold
	// conifer
	// jade
	// lavender
	// light-blue
	// blue
	// seljuk-blue
	// faded-blue
	// spinel-red
	// dark-gray
	// lightest-gray
	// light-gray
	// faded-dark-gray
	// foreground
	// background

	// When clicking on a <details> element, expand it.
	document.addEventListener( 'click', ( event ) => {
		if ( event.target.tagName === 'DETAILS' ) {
			event.target.open = ! event.target.open;
		}
	} );
}() );
